import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../utils/customAuthAxios";
import { useSuccessToast } from "../toast/useSuccessToast";
import { useKuchikomyuSettingFetcherKey } from "./useFetchKuchikomyuSetting";
import { mutate } from 'swr';

export const useEditKuchikomyuSettingByAdmin = (settingsId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();
  const fetcherKey = useKuchikomyuSettingFetcherKey(settingsId);

  const onSubmit = async (data: any) => {
    try {
      const formData = new FormData();
      formData.append('branch_score', data.branch_score);
      formData.append('g_url', data.g_url);
      formData.append('en_url', data.en_url);
      formData.append('default_url', data.default_url);
      formData.append('default_en_url', data.default_en_url);

      // APIに送信
      await customAuthAxios.put(`kuchikomyu/settings/${settingsId}/`, formData);

      // ✅ mutateで即時にローカルデータ更新（Optimistic Update）
      if (fetcherKey) {
        mutate(fetcherKey, (prev: any) => ({
          ...prev,
          branch_score: data.branch_score,
          g_url: data.g_url,
          en_url: data.en_url
        }), false); // false = 再フェッチはしない
      }

      showToast('編集が完了しました');
      navigate(-1);
    } catch (error) {
      console.error("送信失敗:", error);
    }
  };

  return onSubmit;
};